export default __webpack_public_path__ + "static/media/cross-circle.3abefe76.svg";